import Slider from "@/shared/swiper";

document.addEventListener("DOMContentLoaded", () => {
  /**
   * swiper
   */
  const slider = new Slider();
  slider.apply();
});
